import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

import { Search, UserProfileImage } from '@domain-group/suit-theme'

import searchFn from '@functions/search'

import { ContactModel, UserModel } from '@models/types'

import type { EntityOptions } from '@redux/modules/types'

type MapUserResultsParams = {
  contacts: Array<ContactModel>,
  secondaryTextProperty: string,
  selectedIds?: number[],
  users: Array<UserModel>,
}

const mapUserResults = (params: MapUserResultsParams) => {
  const {
    contacts, secondaryTextProperty = '', selectedIds = [], users,
  } = params

  // @ts-expect-error TS7053
  const filteredUsers = users.filter(user => !selectedIds.includes(user.id) && user[secondaryTextProperty] !== null)

  const results = {
    groups: [
      {
        key: 'user',
        title: 'USERS',
        items: filteredUsers.map((user) => {
          const imageUrl = user.image?.thumb_url || ''
          // @ts-expect-error TS7053
          const secondaryText = user?.[secondaryTextProperty] ?? ''

          return {
            ...user,
            iconLeft: (
              <UserProfileImage imageUrl={imageUrl}>
                <FontAwesomeIcon icon={faUser} />
              </UserProfileImage>
            ),
            key: `User-${user.id}`,
            secondaryText,
            text: user.full_name,
          }
        }),
      },
    ],
  }

  if (contacts.length){
    const contactsGroup = {
      key: 'contact',
      title: 'CONTACTS',
      items: contacts.map(contact => ({
        ...contact,
        iconLeft: (
          <UserProfileImage>
            <FontAwesomeIcon icon={faUser} />
          </UserProfileImage>
        ),
        key: `Contact-${contact.id}`,
        // @ts-expect-error TS7053
        secondaryText: contact?.[secondaryTextProperty] ?? '',
        text: contact.full_name,
      })),
    }

    // @ts-expect-error TS2345
    results.groups.push(contactsGroup)
  }

  return results
}

interface UserSearchProps {
  callbacks: {
    onChange: (value: string) => void,
    selectItem: (item: UserModel) => void,
  },
  contacts?: ContactModel[],
  endpoint?: string,
  requestOptions?: EntityOptions,
  secondaryTextProperty: string,
  selectedIds?: number[],
  value: string,
}

const UserSearch = (props: UserSearchProps) => {
  const {
    callbacks: {
      onChange,
      selectItem,
    },
    contacts = [],
    endpoint = 'users.json',
    requestOptions,
    secondaryTextProperty,
    selectedIds,
    value,
  } = props

  return (
    <Search
      callbacks={{
        onChange,
        // @ts-expect-error TS2322
        search: searchFn,
        // @ts-expect-error TS2322
        selectItem,
        // @ts-expect-error TS2322
        mapResults: users => mapUserResults({
          // @ts-expect-error TS2322
          contacts, secondaryTextProperty, selectedIds, users,
        }),
      }}
      debounceInterval={300}
      endpoint={endpoint}
      forwardProps={{
        closeOnSelect: true,
        setStringOnSelect: false,
        showOnFocus: true,
      }}
      requestOptions={{
        ...requestOptions,
        // @ts-expect-error TS2322
        include_image_sizes: true,
        // @ts-expect-error TS2322
        include_user_image: true,
      }}
      value={value}
    />
  )
}

export default UserSearch
